export const languageMap = {
  en: "en",
  sv: "sv",
  en_US: "en",
  en_GB: "en",
  en_AU: "en",
  sv_SE: "sv",
  fi_FI: "fi",
  no_NO: "nn",
  da_DK: "da"
};
